import ReactMarkdown from 'react-markdown'

const formatDate = (seoUpdatedAt) => {
  const date = new Date(seoUpdatedAt)
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  const formattedDate = date.toLocaleDateString(I18n.locale, options)

  return formattedDate
}

const FooterDescription = ({ description, title, seoUpdatedAt }) => (
  <div>
    <hr />
    <div className="d-flex justify-content-between justify-content-end">
      <h2 className="text-primary description-element">{title}</h2>
      {seoUpdatedAt && (
        <span>Last updated at: {formatDate(seoUpdatedAt)}</span>
      )}
    </div>
    {description && (
      <ReactMarkdown source={description} className="description-element" />
    )}
  </div>
)

export default FooterDescription
